<!--
  AnswerOptions
  @param options はい、いいえ、少し
  @param name answerにつけるタグ
-->

<template>
    <div class="btn-group btn-group-toggle" data-toggle="buttons" v-if="options.length===3">
			<label class="btn btn-lg" :class="{'btn-success': 0 == val}">
				<input type="radio" :name="name" autocomplete="off" @click="onSelected(0)" /> {{ options[0] }}
			</label>
      <label class="btn btn-lg" :class="{'btn-warning': 1 == val}">
				<input type="radio" :name="name" autocomplete="off" @click="onSelected(1)" /> {{ options[1] }}
			</label>
      <label class="btn btn-lg" :class="{'btn-danger': 2 == val}">
				<input type="radio" :name="name" autocomplete="off" @click="onSelected(2)" /> {{ options[2] }}
			</label>
    </div>
    <div class="btn-group btn-group-toggle" data-toggle="buttons" v-else>
      <label class="btn btn-lg" :class="{'btn-success': 0 == val}">
				<input type="radio" :name="name" autocomplete="off" @click="onSelected(0)" /> {{ options[0] }}
			</label>
      <label class="btn btn-lg" :class="{'btn-danger': 1 == val}">
				<input type="radio" :name="name" autocomplete="off" @click="onSelected(1)" /> {{ options[1] }}
			</label>
    </div>
</template>

<script>
export default {
  props: [
    'options',
    'name',
    'index',
  ],
  computed: {
    /* 現在選択中の値を取得 */
    val: function() {
      return this.$store.state.answerData[this.$props.index];
    },
  },
  methods: {
    onSelected: function(val) {
      this.$set(this.$store.state.answerData, this.$props.index, val);
    },
  },
}
</script>

<style>

</style>